:root {
  --spl-font-mono: "Consolas", monospace;
  --spl-font-sans: "Consolas", Monaco, monospace;
}

* {
  box-sizing: border-box;
}

html {
  color-scheme: dark;
  min-height: 100%;
}

body {
  margin: 0;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: var(--spl-font-sans);
  background: #000000;
  color: #f5f7fb;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

a {
  color: #1537ff;
}

.shell {
  width: min(72rem, 100vw - 2rem);
  margin: 0 auto;
}

#app > main.shell,
body > main.shell {
  flex: 1 0 auto;
  width: min(72rem, 100vw - 2rem);
  padding-bottom: 2.5rem;
}

.site-header,
.site-footer {
  border-bottom: 2px solid #3a3f4b;
}

.site-footer {
  border-top: 2px solid #3a3f4b;
  border-bottom: 0;
  margin-top: auto;
  flex: 0 0 auto;
}

.footer-row,
.site-header .shell {
  display: flex;
  gap: 1rem;
  padding: 0.8rem 0;
}

.site-header .shell {
  align-items: center;
  justify-content: space-between;
}

.footer-row {
  justify-content: space-between;
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 0.72rem;
  color: #f5f7fb;
  text-decoration: none;
  flex: 0 0 auto;
}

.header-utility {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.9rem;
  flex: 1 1 auto;
  max-width: 42rem;
  margin: 0 auto;
}

.site-search {
  flex: 1 1 auto;
}

.site-search input {
  width: 100%;
  min-height: 2.8rem;
  padding: 0.75rem 1rem;
  border: 2px solid #3a3f4b;
  background: rgba(11, 16, 22, 0.92);
  color: #f5f7fb;
  font-family: var(--spl-font-mono);
  font-size: 0.92rem;
  outline: none;
  transition: border-color 120ms ease, box-shadow 120ms ease;
}

.site-search input::placeholder {
  color: #9aa8bb;
}

.site-search input:focus {
  border-color: #00ffea;
  box-shadow: 0 0 0 3px rgba(0, 255, 234, 0.12);
}

.social-links {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  flex: 0 0 auto;
}

.social-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.6rem;
  height: 2.6rem;
  border: 2px solid #3a3f4b;
  color: #f5f7fb;
  text-decoration: none;
  background: rgba(5, 7, 10, 0.85);
  transition: border-color 120ms ease, color 120ms ease, transform 120ms ease;
}

.social-link svg {
  width: 1rem;
  height: 1rem;
  display: block;
  fill: currentColor;
}

.social-link:hover,
.social-link:focus-visible {
  border-color: #00ffea;
  color: #00ffea;
  transform: translateY(-1px);
}

.logo {
  margin-bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo svg {
  width: 70px;
  height: auto;
  display: block;
  color: #ffffff;
  overflow: visible;
  shape-rendering: geometricPrecision;
}

.logo-mark path {
  fill: none;
  stroke: currentColor;
  stroke-width: 34;
  stroke-linecap: square;
  stroke-linejoin: miter;
  stroke-dasharray: none;
  paint-order: fill markers stroke;
}

.wordmark {
  font-family: var(--spl-font-mono);
  font-weight: 700;
  font-size: 0.95rem;
  letter-spacing: 0.04em;
  color: #f5f7fb;
  text-transform: lowercase;
}

.footer-credit {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.55rem;
  margin-left: auto;
  white-space: nowrap;
}

.footer-credit img {
  width: 1.35rem;
  height: 1.35rem;
  display: block;
  filter: brightness(0) invert(1);
}

.footer-credit-link {
  display: inline-flex;
  align-items: center;
}

.archive-controls {
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 0;
  margin-top: 1.1rem;
  padding: 0.25rem 0 0.45rem;
}

.archive-summary {
  display: flex;
  align-items: baseline;
  justify-content: flex-start;
  gap: 0.6rem;
  font-family: var(--spl-font-mono);
  margin-right: auto;
}

.archive-summary strong {
  font-size: 2.35rem;
  line-height: 1;
}

.archive-summary span {
  color: #9aa8bb;
  font-size: 0.82rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.archive-tree {
  margin-top: 0.65rem;
  padding-bottom: 1rem;
}

.archive-tree-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.archive-tree-list-root {
  padding-left: 0;
}

.archive-tree-list .archive-tree-list {
  margin-left: 1.05rem;
  padding-left: 1.15rem;
  border-left: 1px solid rgba(154, 168, 187, 0.24);
}

.archive-tree-node {
  position: relative;
}

.archive-branch {
  margin: 0;
}

.archive-branch-summary,
.archive-leaf {
  position: relative;
  display: grid;
  grid-template-columns: 1.1rem 1.2rem minmax(0, 1fr) auto;
  align-items: center;
  gap: 0.6rem;
  min-height: 2.55rem;
  padding: 0.34rem 0.5rem;
  border: 1px solid transparent;
  border-radius: 4px;
  color: #f5f7fb;
  text-decoration: none;
}

.archive-branch-summary {
  cursor: pointer;
  list-style: none;
}

.archive-branch-summary::-webkit-details-marker {
  display: none;
}

.archive-branch-caret {
  width: 0.48rem;
  height: 0.48rem;
  justify-self: center;
  border-right: 1px solid #9aa8bb;
  border-bottom: 1px solid #9aa8bb;
  transform: rotate(-45deg);
  transition: transform 120ms ease, border-color 120ms ease;
}

.archive-branch-caret-spacer {
  border: 0;
  transform: none;
}

.archive-node-icon {
  width: 1.2rem;
  height: 1rem;
  position: relative;
  color: #9aa8bb;
  justify-self: center;
}

.archive-node-icon-folder::before,
.archive-node-icon-folder::after,
.archive-node-icon-file::before,
.archive-node-icon-file::after {
  content: "";
  position: absolute;
  display: block;
}

.archive-node-icon-folder::before {
  left: 0.08rem;
  top: 0.36rem;
  width: 0.98rem;
  height: 0.52rem;
  border: 1px solid currentColor;
  background: transparent;
}

.archive-node-icon-folder::after {
  left: 0.16rem;
  top: 0.18rem;
  width: 0.44rem;
  height: 0.22rem;
  border: 1px solid currentColor;
  border-bottom: 0;
}

.archive-node-icon-file::before {
  left: 0.22rem;
  top: 0.1rem;
  width: 0.72rem;
  height: 0.84rem;
  border: 1px solid currentColor;
}

.archive-node-icon-file::after {
  right: 0.22rem;
  top: 0.1rem;
  width: 0.25rem;
  height: 0.25rem;
  border-left: 1px solid currentColor;
  border-bottom: 1px solid currentColor;
}

.archive-branch[open] > .archive-branch-summary .archive-branch-caret {
  transform: rotate(45deg);
}

.archive-branch-summary:hover,
.archive-branch-summary:focus-visible,
.archive-leaf:hover,
.archive-leaf:focus-visible {
  border-color: rgba(0, 255, 234, 0.24);
  background: rgba(11, 16, 22, 0.42);
  outline: none;
}

.archive-branch-summary:hover .archive-branch-caret,
.archive-branch-summary:focus-visible .archive-branch-caret {
  border-color: #00ffea;
}

.archive-branch-summary:hover .archive-node-icon,
.archive-branch-summary:focus-visible .archive-node-icon,
.archive-leaf:hover .archive-node-icon,
.archive-leaf:focus-visible .archive-node-icon {
  color: #00ffea;
}

.archive-branch-title,
.archive-leaf-title {
  min-width: 0;
  font-size: 0.98rem;
  font-weight: 600;
  line-height: 1.3;
  overflow-wrap: anywhere;
}

.archive-branch-title a {
  color: #f5f7fb;
  text-decoration: none;
}

.archive-branch-title a:hover,
.archive-branch-title a:focus-visible {
  color: #00ffea;
}

.archive-branch-count,
.archive-leaf-meta {
  color: #9aa8bb;
  font-family: var(--spl-font-mono);
  font-size: 0.74rem;
  white-space: nowrap;
}

.archive-leaf-meta {
  display: inline-flex;
  gap: 0.65rem;
  flex-wrap: wrap;
  justify-self: end;
  text-align: right;
}

.archive-tree-node-article[hidden],
.archive-tree-node-group[hidden] {
  display: none;
}

.article-hero-image img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #0b1016;
}

.article-series-meta,
.series-context-label,
.series-count,
.series-chapter-index,
.series-nav-label,
.series-kicker {
  margin: 0;
  color: #9aa8bb;
  font-family: var(--spl-font-mono);
  font-size: 0.82rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.article-series-meta {
  display: flex;
  gap: 0.45rem;
  flex-wrap: wrap;
}

.article-series-meta a,
.series-context a,
.series-entry-card a,
.series-nav-link strong {
  color: #00ffea;
  text-decoration: none;
}

.article-series-meta a:hover,
.article-series-meta a:focus-visible,
.series-context a:hover,
.series-context a:focus-visible,
.series-entry-card a:hover,
.series-entry-card a:focus-visible,
.series-nav-link:hover strong,
.series-nav-link:focus-visible strong {
  text-decoration: underline;
}

.article-rule {
  display: none;
}

.article-meta,
.eyebrow,
.article-author,
.tags,
.empty,
.site-footer {
  color: #9aa8bb;
}

.article-meta,
.tags {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  padding: 0;
  list-style: none;
}

.article-author {
  margin: auto 0 0;
  align-self: flex-end;
  font-size: 0.9rem;
  text-align: right;
}

.article-card h2,
.article-header h1 {
  margin: 0;
  font-family: var(--spl-font-mono);
  font-size: clamp(2rem, 5vw, 4.5rem);
}

.article-card h2 {
  font-size: clamp(1.55rem, 2.6vw, 2.2rem);
  line-height: 1.03;
  max-width: none;
}

.article-card h2 a {
  display: block;
  width: 100%;
  color: #f5f7fb;
  text-decoration: none;
}

.article-card h2 a:hover,
.article-card h2 a:focus-visible {
  color: #00ffea;
  text-decoration: none;
}

.article-subtitle {
  margin: 0;
  color: #9aa8bb;
  font-size: 0.95rem;
  font-family: var(--spl-font-mono);
}

.article-subtitle-large {
  font-size: 1.15rem;
}

.lede {
  font-size: 1.1rem;
  max-width: 58ch;
  margin-left: auto;
  margin-right: auto;
}

.article-card .lede,
.article-card p {
  margin: 0;
}

.article-excerpt {
  color: #d2dae4;
  line-height: 1.5;
  max-width: 52ch;
}

.hero-actions {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
}

.article-page {
  margin-top: 1.4rem;
  padding: 0;
  background: transparent;
  border: 0;
}

.article-header,
.prose,
.article-page > p {
  width: min(100%, 52rem);
  margin-left: auto;
  margin-right: auto;
}

.article-page > p {
  margin-top: 0;
  margin-bottom: 1.25rem;
}

.article-header {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.series-context {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  padding: 0.9rem 1rem;
  border: 2px solid #3a3f4b;
  background: rgba(11, 16, 22, 0.78);
}

.series-context-body {
  display: flex;
  gap: 0.45rem;
  flex-wrap: wrap;
  margin: 0;
}

.article-header h1,
.article-header .article-subtitle,
.article-header .eyebrow,
.article-header .tags,
.prose > * {
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

.article-header .tags {
  justify-content: flex-start;
}

.article-hero-image {
  margin-top: 1.5rem;
  border: 2px solid #3a3f4b;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(21, 55, 255, 0.12), rgba(24, 255, 91, 0.03));
  aspect-ratio: 16/7;
}

.prose {
  line-height: 1.75;
  font-size: 1.06rem;
  margin-top: 2rem;
}

.prose pre,
.prose code {
  font-family: var(--spl-font-mono);
}

.prose pre {
  overflow-x: auto;
  padding: 1rem;
  border: 2px solid #3a3f4b;
  background: #0b1016;
}

.back-link {
  text-decoration: none;
  font-family: var(--spl-font-mono);
}

.series-nav {
  width: min(100%, 52rem);
  margin: 2.25rem auto 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}

.series-nav-link {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  min-height: 6.5rem;
  padding: 1rem;
  border: 2px solid #3a3f4b;
  background: rgba(5, 7, 10, 0.85);
  text-decoration: none;
  color: #f5f7fb;
}

.series-nav-link-next {
  text-align: right;
  align-items: flex-end;
}

.series-nav-link strong {
  color: #f5f7fb;
  font-size: 1.1rem;
}

.series-nav-link.is-empty {
  visibility: hidden;
}

.series-page {
  width: min(100%, 56rem);
  margin: 1.4rem auto 0;
}

.series-header {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 2rem;
}

.series-header h1,
.series-section-heading h2,
.series-entry-card h3 {
  margin: 0;
}

.series-header h1 {
  font-size: clamp(2.4rem, 5vw, 4.2rem);
}

.series-section {
  margin-top: 2rem;
}

.series-section-heading {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin-bottom: 0.9rem;
}

.series-entry-list {
  display: grid;
  gap: 0.85rem;
  padding: 0;
  margin: 0;
  list-style: none;
}

.series-entry-card {
  display: grid;
  grid-template-columns: 3.5rem minmax(0, 1fr);
  gap: 1rem;
  padding: 1rem;
  border: 2px solid #3a3f4b;
  background: rgba(5, 7, 10, 0.85);
}

.series-entry-card p,
.series-entry-card h3 {
  margin-top: 0;
  margin-bottom: 0;
}

.series-entry-order {
  color: #00ffea;
  font-family: var(--spl-font-mono);
  font-size: 1.2rem;
}

@media (max-width: 980px) {
  .site-header .shell {
    flex-wrap: wrap;
  }
  .header-utility {
    max-width: none;
    margin: 0;
  }
}
@media (max-width: 720px) {
  .logo svg {
    width: 60px;
  }
  .wordmark {
    font-size: 0.84rem;
  }
  .header-utility {
    width: 100%;
    flex-direction: column;
    align-items: stretch;
  }
  .social-links {
    justify-content: flex-end;
  }
  .footer-row {
    flex-direction: column;
    align-items: flex-start;
  }
  .footer-credit {
    margin-left: 0;
    justify-content: flex-start;
  }
  .article-list.layout-list .article-card {
    flex-direction: column;
  }
  .article-list.layout-list .article-cover {
    flex-basis: auto;
    border-right: 0;
    border-bottom: 2px solid #3a3f4b;
    aspect-ratio: 16/9;
    min-height: auto;
  }
  .article-list.layout-list .article-card-text-only .article-body {
    max-width: none;
  }
  .series-nav {
    grid-template-columns: 1fr;
  }
  .series-nav-link-next {
    text-align: left;
    align-items: flex-start;
  }
}
.tags li {
  padding: 0.22rem 0.58rem;
  border: 2px solid #3a3f4b;
  color: #f5f7fb;
  font-family: var(--spl-font-mono);
  font-size: 0.8rem;
}

.tags-large {
  margin-top: 1.25rem;
}

@media (max-width: 720px) {
  .footer-row,
  .site-header .shell {
    flex-direction: column;
    align-items: flex-start;
  }
  .archive-controls {
    flex-direction: column;
    align-items: flex-start;
  }
  .layout-switch {
    width: 100%;
  }
  .layout-button {
    flex: 1 1 0;
  }
  .site-nav {
    flex-direction: column;
  }
  .article-list.layout-list .article-card {
    flex-direction: column;
  }
  .article-list.layout-list .article-cover {
    border-right: 0;
    border-bottom: 2px solid #3a3f4b;
  }
  .hero,
  .article-card,
  .article-page {
    padding: 1.25rem;
  }
  .series-entry-card {
    grid-template-columns: 1fr;
    gap: 0.55rem;
  }
}
@media (max-width: 520px) {
  .shell {
    width: min(72rem, 100vw - 1rem);
  }
  .site-search input {
    min-height: 2.65rem;
    padding: 0.7rem 0.85rem;
    font-size: 0.86rem;
  }
  .social-links {
    width: 100%;
    justify-content: space-between;
  }
  .social-link {
    flex: 1 1 0;
  }
  .article-body {
    padding: 1rem;
  }
  .article-card h2,
  .article-header h1 {
    line-height: 1.06;
  }
  .article-meta,
  .tags {
    gap: 0.45rem;
  }
}
